import React from 'react';
import './style.scss';
import Lotto2 from './Lotto2';

function App() {
    return (
        <div className="App">
            <Lotto2 />
        </div>
    );
}

export default App;
